
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch } from 'react-redux';

import { getActions } from '../sagas';
import { ToolButton } from '../../core';

const ButtonCommandClose = (props) => {

    const dispatch = useDispatch();
    const onClick = () => {
        getActions(dispatch).setMmsPoint(null);
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE}
            iconProps={ToolButton.getIcon('Cancel')}
            title="Zavřít"
            onClick={onClick}
        />
    );
}

export default ButtonCommandClose;
